/**
 * The external dependencies.
 */
import {all, call, takeLatest} from 'redux-saga/effects';
import * as R from "ramda";
/**
 * The internal dependencies.
 */
import request from '../../common/request';
import {dispoGetDepartmentsConfig, dispoGetUser, dispoStoreUser} from "../dispo/actions";
import store from "../index";
import {tasksRequest} from "../tasks/actions";
import {dispoGetDepartments, dispoStoreDepartments, dispoStoreDepartmentsConfig, dispoTaskUpdate} from "./actions";

/**
 * Start a network request to fetch content.
 *
 * @param  {Object}    action
 * @return {Generator}
 */
export function* workerGetUsers(action) {

    yield call(request, {
        endpoint: 'getWorkerForDispo',
        params: [],
        requestAction: action,
        receiveAction: dispoStoreUser,
    });
}

export function* workerGetDepartments(action) {

    yield call(request, {
        endpoint: 'getDepartmentForDispo',
        params: [],
        requestAction: action,
        receiveAction: dispoStoreDepartments,
    });
}

export function* workerGetDepartmentsConfig(action) {

    yield call(request, {
        endpoint: 'getDepartmentConfig',
        params: [{id: action.payload}],
        requestAction: action,
        receiveAction: dispoStoreDepartmentsConfig,
    });
}

export function* workerDispoTasksUpdate(action) {
    const mytasks = R.clone(store.getState().tasks.items);
    const index = R.findIndex(R.propEq('id', action.payload.id))(mytasks);
    const task = mytasks[index];
    // console.log("WhatsUp??", task, action.payload.data);

    if (action.payload.data !== undefined && action.payload.data.enabled === true) {
        yield null;
    } else {
        yield call(request, {
            endpoint: 'dispoUpdateTask',
            params: [{task: task, update: action.payload.data}],
            requestAction: action,
            receiveAction: tasksRequest,
        });
    }
}

/**
 * Coordinate the workers.
 *
 * @return {Generator}
 */
export default function* ContentForeman() {
    yield all([
        takeLatest(dispoGetUser, workerGetUsers),
        takeLatest(dispoGetDepartments, workerGetDepartments),
        takeLatest(dispoTaskUpdate, workerDispoTasksUpdate),
        takeLatest(dispoGetDepartmentsConfig, workerGetDepartmentsConfig),
    ]);
}



// WEBPACK FOOTER //
// ./src/store/dispo/effects.js